import TabbedSections from "@/components/TabbedSections";
import { sectionsByGroup } from "@/config/sections";

// 관리자(/admin) — 운영 계정 관리 중심 (2026-08-21 IA 재편).
// 기존 고객 문의(CxSection) → /tickets 으로 이동.
// 기존 DevOps(DevopsSection) → /system 으로 이동.
// Admin에는 사용자 관리 / 계정 Role / 크레딧만 남는다.
// 탭 구성·순서는 config/sections.jsx 의 admin 그룹이 단일 소스다.
const TABS = sectionsByGroup("admin");

export default function AdminPage() {
  return <TabbedSections tabs={TABS} hideTabs />;
}
